import { SxProps, Theme } from '@mui/material/styles';

export enum PageImageId {
  FalkoZander = 'falko-zander',
  Home = 'home',
  InstructorProgram = 'instructor-program',
  Kampfkunst = 'kampfkunst',
  PU = 'pu',
  Ranking = 'ranking',
  Training = 'training',
  Vip = 'vip',
}

export type Config = {
  subtitle?: string;
  sxH1: SxProps<Theme>;
  sxImage: SxProps<Theme>;
  sxWrapper: SxProps<Theme>;
  title?: string;
};
